import { itemAction } from "../actionTypes"

const initialState = {
  itemList: {},
  itemOptions: [],
  loader: false,
}

export default function item(state = initialState, { type, payload }) {
  switch (type) {
    case itemAction.ITEM_LIST_INITIATE:
      return { ...state, loader: true }
    case itemAction.ITEM_LIST_SUCCESS:
      return { ...state, loader: false, itemList: payload.data }
    case itemAction.ITEM_LIST_FAILURE:
      return { ...state, loader: false }
    case itemAction.ITEM_OPTIONS_SUCCESS:
      return { ...state, itemOptions: payload.data }
    default:
      return state
  }
}
